import { useState, ImgHTMLAttributes } from 'react';
import clsx from 'clsx';

interface ImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  src: string | undefined | null;
  alt: string;
  fill?: boolean;
  sizes?: string;
  priority?: boolean;
  className?: string;
}

export default function Image({
  src,
  alt,
  fill = false,
  sizes,
  priority = false,
  className,
  ...props
}: ImageProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);

  if (!src || error) {
    return (
      <div
        className={clsx(
          'flex items-center justify-center bg-neutral-200 dark:bg-neutral-800',
          className,
          fill && 'absolute inset-0'
        )}
      >
        <span className="text-neutral-400 text-sm">Image non disponible</span>
      </div>
    );
  }

  const imageClasses = clsx(
    className,
    fill && 'absolute inset-0 w-full h-full object-cover',
    isLoading && 'opacity-0',
    !isLoading && 'opacity-100 transition-opacity duration-300'
  );

  return (
    <img
      src={src}
      alt={alt}
      loading={priority ? 'eager' : 'lazy'}
      className={imageClasses}
      onLoad={() => setIsLoading(false)}
      onError={() => setError(true)}
      {...props}
    />
  );
}



